import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27db9cd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-work-reports-section" }
const _hoisted_2 = { class: "body bg-white" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-section-spacing" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "font-bold block text-left" }, "Ultimi rapportini")
], -1))
const _hoisted_4 = { class: "user-work-reports w-full" }
const _hoisted_5 = { class: "titles-working-site-clocking-ins grid grid-cols-5 text-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, "Data creazione rapportino", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, "Ore di lavoro", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, "Dipendenti", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "shift" }, null, -1))
const _hoisted_10 = { class: "clocking-ins-list list overflow-y-hidden overflow-x-hidden" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-bold justify-between items-center pt-2 pr-8 cursor-pointer select-none text-right text-primary-600" }, "Vedi tutti i rapportini", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkReportCard = _resolveComponent("WorkReportCard")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(_ctx.scope == _ctx.WorkReportScope.workingSite ? 'Nome dipendente' : 'Nome cantiere'), 1),
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workReports, (workReport) => {
            return (_openBlock(), _createBlock(_component_WorkReportCard, {
              "model-value": workReport,
              scope: _ctx.scope
            }, null, 8, ["model-value", "scope"]))
          }), 256)),
          _createVNode(_component_router_link, {
            class: "block focus:outline-none focus:shadow-outline",
            type: "button",
            to: _ctx.workReportsUrl
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ])
  ]))
}